document.addEventListener("DOMContentLoaded", function () {
	const nav = document.querySelector("#main-nav");
	const adminBar = document.querySelector("#wpadminbar");

	function handleSticky() {
		// Calcul de la hauteur de la barre admin (souvent 32px sur PC)
		const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;

		if (window.scrollY > 50) {
			nav.style.position = "fixed";
			nav.style.top = adminBarHeight + "px"; // Se colle sous la barre WP
			nav.classList.add("navbar-scrolled");
		} else {
			nav.style.position = "relative";
			nav.style.top = "0";
			nav.classList.remove("navbar-scrolled");
		}
	}

	window.addEventListener("scroll", handleSticky);
	window.addEventListener("resize", handleSticky); // Recalcule si on tourne l'écran

	// back to the top
	var backToTopButton = document.getElementById("back-to-top");
	if (backToTopButton) {
		var toggleBackToTop = function () {
			if (window.scrollY > 300) {
				backToTopButton.classList.remove("d-none");
				backToTopButton.classList.add("show");
			} else {
				backToTopButton.classList.remove("show");
				backToTopButton.classList.add("d-none");
			}
		};

		window.addEventListener("scroll", toggleBackToTop);

		toggleBackToTop();

		backToTopButton.addEventListener("click", function (e) {
			e.preventDefault();
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		});
	}

	//preloader

	const preloader = document.getElementById("preloader");

	// On ajoute une petite seconde de délai pour que l'utilisateur voit l'animation
	// même sur les connexions ultra-rapides (effet pro)
	setTimeout(() => {
		preloader.classList.add("fade-out");

		// On retire complètement du DOM après l'animation pour libérer des ressources
		setTimeout(() => {
			preloader.style.display = "none";
		}, 500);
	}, 1000);
});
